import pdfMake from 'pdfmake/build/pdfmake';

// Dynamically load vfs fonts to avoid initialization timing issues
try {
  const pdfFonts = require('pdfmake/build/vfs_fonts');
  if (pdfFonts) {
    pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs || pdfFonts;
  }
} catch (e) {
  console.warn('pdfmake vfs fonts not available:', e.message);
}

const DISCLAIMER = `This document has been prepared by Agreya Capital Advisors LLP ("Agreya"), a SEBI registered Portfolio Manager (SEBI Registration Number INP000006077) for information purposes only. No liability is accepted by Agreya or its representative whatsoever for any direct, indirect or consequential loss arising from the use of this document. This document is not intended as an offer or publication or solicitation for distribution or for subscription of or purchase or sale of any securities or financial instruments(s) to anyone. The information contained in this document shall not be published, reproduced or disseminated without specific confirmation from Agreya. Any person/s accessing data contained in this presentation, hereby confirms that they are not a U.S. person, within the definition of the term "US Person" under the US Securities laws.`;

const NOTES_COMMON = [
  'Returns are assumed to be generated linearly through the year.',
  'All Fees and charges are subject to GST at 18% or as per extant regulations',
  'All Amounts are in INR.',
];

const formatNumber = (value) => {
  if (value !== undefined && value !== null) {
    const formattedValue = Object.is(value, -0) ? 0 : value;
    if (formattedValue < 0) {
      return `(${Math.abs(formattedValue).toLocaleString()})`;
    }
    return formattedValue.toLocaleString();
  }
  return 'N/A';
};

const buildFixedFeeContent = (scenarios, assumptions, selectedApproach) => {
  const tableBody = [
    [
      { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      {},
      {},
    ],
    [
      { text: 'Capital Contribution (Rs.)', bold: true },
      { text: 'a', bold: true, alignment: 'center' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
    ],
    [
      'Management Fee (% per annum)',
      { text: 'b', alignment: 'center' },
      { text: `${assumptions.b}%`, alignment: 'right' },
    ],
    [
      'Other Expenses (% pa including GST)',
      { text: 'c', alignment: 'center' },
      { text: `${assumptions.c}%`, alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost (% pa including GST)',
      { text: 'd', alignment: 'center' },
      { text: `${assumptions.d}%`, alignment: 'right' },
    ],
  ];

  const scenarioTable = [
    [
      { text: 'Fee Illustration', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Variable', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Formula', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 1\nGain of 20%', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 2\nLoss of 20%', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 3\nNil Gain/Loss', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
    ],
    [
      'Capital Contributed / Assets under Management',
      { text: 'i', alignment: 'center' },
      { text: 'i = a', alignment: 'center' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
    ],
    [
      'Gain / (Loss) on Investment based on the Scenario',
      { text: 'ii', alignment: 'center' },
      { text: 'ii = i * Scenario', alignment: 'center' },
      { text: formatNumber(scenarios[0].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[1].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[2].gainOrLoss), alignment: 'right' },
    ],
    [
      'Gross Value of the Portfolio at the end of the year',
      { text: 'iii', alignment: 'center' },
      { text: 'iii = i + ii', alignment: 'center' },
      { text: formatNumber(scenarios[0].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[1].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[2].grossValue), alignment: 'right' },
    ],
    [
      'Average assets under management',
      { text: 'iv', alignment: 'center' },
      { text: 'iv = (i + iii) / 2', alignment: 'center' },
      { text: formatNumber(scenarios[0].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[1].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[2].averageAUM), alignment: 'right' },
    ],
    [
      'Other Expense',
      { text: 'v', alignment: 'center' },
      { text: 'v = iv * c', alignment: 'center' },
      { text: formatNumber(scenarios[0].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[1].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[2].otherExpense), alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost',
      { text: 'vi', alignment: 'center' },
      { text: 'vi = iv * d', alignment: 'center' },
      { text: formatNumber(scenarios[0].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[1].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[2].brokerageCost), alignment: 'right' },
    ],
    [
      'Management Fees',
      { text: 'vii', alignment: 'center' },
      { text: 'vii = (iv + v + vi) * b', alignment: 'center' },
      { text: formatNumber(scenarios[0].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[1].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[2].managementFees), alignment: 'right' },
    ],
    [
      'GST on Management Fees',
      { text: 'viii', alignment: 'center' },
      { text: 'viii = vii * 18%', alignment: 'center' },
      { text: formatNumber(scenarios[0].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].gstOnManagementFee), alignment: 'right' },
    ],
    [
      'Total charges during the year',
      { text: 'ix', alignment: 'center' },
      { text: 'ix = v + vi + vii + viii', alignment: 'center' },
      { text: formatNumber(scenarios[0].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[1].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[2].totalCharges), alignment: 'right' },
    ],
    [
      'Net value of the Portfolio at the end of the year',
      { text: 'x', alignment: 'center' },
      { text: 'x = iii + ix', alignment: 'center' },
      { text: formatNumber(scenarios[0].netValue), alignment: 'right' },
      { text: formatNumber(scenarios[1].netValue), alignment: 'right' },
      { text: formatNumber(scenarios[2].netValue), alignment: 'right' },
    ],
    [
      '% Portfolio Return',
      { text: 'xi', alignment: 'center' },
      { text: 'xi = ((x - i) / i) %', alignment: 'center' },
      { text: `${scenarios[0].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
      { text: `${scenarios[1].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
      { text: `${scenarios[2].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
    ],
  ];

  const notes = [
    'Returns are assumed to be generated linearly through the year.',
    'Other Expenses includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense',
    'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades.',
    'All Fees and charges are subject to GST at 18% or as per extant regulations',
    'All Amounts are in INR.',
  ];

  return {
    title: `FIXED FEE MODEL - ${selectedApproach}`,
    assumptionsTable: tableBody,
    scenarioTable,
    notes,
  };
};

const buildHybridFeeContent = (scenarios, assumptions, selectedApproach) => {
  const assumptionsTableBody = [
    [
      { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      {},
      {},
    ],
    [
      'Capital Contribution (Rs.)',
      { text: 'a', alignment: 'center' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
    ],
    [
      'Management Fee (% per annum)',
      { text: 'b', alignment: 'center' },
      { text: `${assumptions.b}%`, alignment: 'right' },
    ],
    [
      'Other Expenses (% pa including GST)',
      { text: 'c', alignment: 'center' },
      { text: `${assumptions.c}%`, alignment: 'right' },
    ],
    [
      'Performance Fee(% per annum)',
      { text: 'd', alignment: 'center' },
      { text: `${assumptions.e}%`, alignment: 'right' },
    ],
    [
      'Hurdle Rate of Return (% per annum)',
      { text: 'e', alignment: 'center' },
      { text: assumptions.f, alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost (% pa including GST)',
      { text: 'f', alignment: 'center' },
      { text: `${assumptions.d}%`, alignment: 'right' },
    ],
  ];

  const scenarioTable = [
    [
      { text: 'Fee Illustration', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Variable', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Formula', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 1\nGain of 20%', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 2\nLoss of 20%', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Scenario 3\nNil Gain/Loss', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
    ],
    [
      'Capital Contributed / Assets under Management',
      { text: 'i', alignment: 'center' },
      { text: 'i = a', alignment: 'center' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
    ],
    [
      'Gain / (Loss) on Investment based on the Scenario',
      { text: 'ii', alignment: 'center' },
      { text: 'ii = i * Scenario', alignment: 'center' },
      { text: formatNumber(scenarios[0].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[1].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[2].gainOrLoss), alignment: 'right' },
    ],
    [
      'Gross Value of the Portfolio at the end of the year',
      { text: 'iii', alignment: 'center' },
      { text: 'iii = i + ii', alignment: 'center' },
      { text: formatNumber(scenarios[0].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[1].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[2].grossValue), alignment: 'right' },
    ],
    [
      'Daily Weighted Average assets under management',
      { text: 'iv', alignment: 'center' },
      { text: 'iv = (i + iii) / 2', alignment: 'center' },
      { text: formatNumber(scenarios[0].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[1].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[2].averageAUM), alignment: 'right' },
    ],
    [
      'Other Expense',
      { text: 'v', alignment: 'center' },
      { text: 'v = iv * c', alignment: 'center' },
      { text: formatNumber(scenarios[0].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[1].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[2].otherExpense), alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost',
      { text: 'vi', alignment: 'center' },
      { text: 'vi = iv * f', alignment: 'center' },
      { text: formatNumber(scenarios[0].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[1].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[2].brokerageCost), alignment: 'right' },
    ],
    [
      'Management Fees',
      { text: 'vii', alignment: 'center' },
      { text: 'vii = (iv + v + vi) * b', alignment: 'center' },
      { text: formatNumber(scenarios[0].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[1].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[2].managementFees), alignment: 'right' },
    ],
    [
      'GST on Management Fee',
      { text: 'viii', alignment: 'center' },
      { text: 'viii = vii * 18%', alignment: 'center' },
      { text: formatNumber(scenarios[0].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].gstOnManagementFee), alignment: 'right' },
    ],
    [
      'Total charges excluding Performance fee',
      { text: 'ix', alignment: 'center' },
      { text: 'ix = v + vi + vii + viii', alignment: 'center' },
      { text: formatNumber(scenarios[0].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[1].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[2].totalCharges), alignment: 'right' },
    ],
    [
      'Gross Value of the Portfolio before Performance fee',
      { text: 'x', alignment: 'center' },
      { text: 'x = iii + ix', alignment: 'center' },
      { text: formatNumber(scenarios[0].grossValueBeforePerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].grossValueBeforePerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].grossValueBeforePerformanceFee), alignment: 'right' },
    ],
    [
      'Hurdle Value',
      { text: 'xi', alignment: 'center' },
      { text: 'xi = i * (1+e)', alignment: 'center' },
      { text: formatNumber(scenarios[0].HurdleValue), alignment: 'right' },
      { text: formatNumber(scenarios[1].HurdleValue), alignment: 'right' },
      { text: formatNumber(scenarios[2].HurdleValue), alignment: 'right' },
    ],
    [
      'Performance Fee Applicability',
      { text: 'xii', alignment: 'center' },
      { text: 'xii = x > xi, then Yes else No', alignment: 'center' },
      { text: scenarios[0].grossValueBeforePerformanceFee > scenarios[0].HurdleValue ? 'Yes' : 'No', alignment: 'center' },
      { text: scenarios[1].grossValueBeforePerformanceFee > scenarios[1].HurdleValue ? 'Yes' : 'No', alignment: 'center' },
      { text: scenarios[2].grossValueBeforePerformanceFee > scenarios[2].HurdleValue ? 'Yes' : 'No', alignment: 'center' },
    ],
    [
      { text: 'If Yes, proceed to performance fee calculation else 0 (zero) performance fee for the period', colSpan: 6, alignment: 'center' },
      {},
      {},
      {},
      {},
      {},
    ],
    [
      'Portfolio return eligible for Performance Fee',
      { text: 'xiii', alignment: 'center' },
      { text: 'xiii = x - xi', alignment: 'center' },
      { text: formatNumber(scenarios[0].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
    ],
    [
      'Performance fee',
      { text: 'xiv', alignment: 'center' },
      { text: 'xiv = xiii * d', alignment: 'center' },
      { text: formatNumber(scenarios[0].performanceFeeAmount), alignment: 'right' },
      { text: formatNumber(scenarios[1].performanceFeeAmount), alignment: 'right' },
      { text: formatNumber(scenarios[2].performanceFeeAmount), alignment: 'right' },
    ],
    [
      'GST on Performance Fee',
      { text: 'xv', alignment: 'center' },
      { text: 'xv = xiv * 18%', alignment: 'center' },
      { text: formatNumber(scenarios[0].gstOnPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].gstOnPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].gstOnPerformanceFee), alignment: 'right' },
    ],
    [
      'Net Value of the Portfolio at the end of the year after all fees',
      { text: 'xvi', alignment: 'center' },
      { text: 'xvi = x + xiv + xv', alignment: 'center' },
      { text: formatNumber(scenarios[0].netValueAfterFees), alignment: 'right' },
      { text: formatNumber(scenarios[1].netValueAfterFees), alignment: 'right' },
      { text: formatNumber(scenarios[2].netValueAfterFees), alignment: 'right' },
    ],
    [
      '% Portfolio Return for the year',
      { text: 'xvii', alignment: 'center' },
      { text: 'xvii = ((xvi - i) / i) %', alignment: 'center' },
      { text: `${scenarios[0].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
      { text: `${scenarios[1].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
      { text: `${scenarios[2].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
    ],
    [
      'High Water Mark to be carried forward for next year (when performance fee is charged to the portfolio)',
      { text: 'xviii', alignment: 'center' },
      { text: 'xviii = Max(xi, xvi)', alignment: 'center' },
      { text: formatNumber(scenarios[0].highWaterMarkFromPortfolio), alignment: 'right' },
      { text: formatNumber(scenarios[1].highWaterMarkFromPortfolio), alignment: 'right' },
      { text: formatNumber(scenarios[2].highWaterMarkFromPortfolio), alignment: 'right' },
    ],
    [
      'High Water Mark to be carried forward for next year (when performance fee is paid separately by investor)',
      { text: 'xix', alignment: 'center' },
      { text: 'xix = Max(x, xi)', alignment: 'center' },
      { text: formatNumber(scenarios[0].highWaterMarkFromInvestor), alignment: 'right' },
      { text: formatNumber(scenarios[1].highWaterMarkFromInvestor), alignment: 'right' },
      { text: formatNumber(scenarios[2].highWaterMarkFromInvestor), alignment: 'right' },
    ],
  ];

  const notes = [
    'Returns are assumed to be generated linearly through the year.',
    'Other Expense includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense.',
    'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades.',
    'All Fees and charges are subject to GST at 18% or as per extant regulations',
    'Hurdle computation is prorated in case the performance fee period is less than 1 year OR if there are inflow/outflows from the portfolio.',
    'All Amounts are in INR',
  ];

  return {
    title: `HYBRID FEE MODEL - ${selectedApproach}`,
    assumptionsTable: assumptionsTableBody,
    scenarioTable,
    notes,
  };
};

const buildMultiYearRow = (label, variable, formula, values) => {
  return [
    label,
    { text: variable, alignment: 'center' },
    { text: formula, alignment: 'center' },
    ...values.map(value => ({ text: value.toString(), alignment: 'right' })),
  ];
};

const buildPortfolioOptimiserContent = (scenarios, assumptions, selectedApproach) => {
  const assumptionsTableBody = [
    [
      { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      {},
      {},
    ],
    [
      'Capital Contribution',
      { text: 'a', alignment: 'center' },
      { text: formatNumber(assumptions.a), alignment: 'right' },
    ],
    [
      'Cash Component out of Total Capital',
      { text: 'b', alignment: 'center' },
      { text: formatNumber(assumptions.a * 0.02), alignment: 'right' },
    ],
    [
      'Management Fee (%age per annum)',
      { text: 'c', alignment: 'center' },
      { text: `${assumptions.b}%`, alignment: 'right' },
    ],
    [
      'Other Expenses (% pa including GST)',
      { text: 'd', alignment: 'center' },
      { text: `${assumptions.c}%`, alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost (% pa including GST)',
      { text: 'e', alignment: 'center' },
      { text: `${assumptions.d}%`, alignment: 'right' },
    ],
    [
      'Performance Fee(%age per annum)',
      { text: 'f', alignment: 'center' },
      { text: `${assumptions.e}%`, alignment: 'right' },
    ],
  ];

  const generatePROScenarioHeader = (index, gainOrLoss) => {
    if (gainOrLoss < 0) {
      return `Scenario ${index + 1}\nLoss of Rs.\n${Math.abs(gainOrLoss).toLocaleString()}`;
    } else if (gainOrLoss === 0) {
      return `Scenario ${index + 1}\nNil\nGain/Loss`;
    } else {
      return `Scenario ${index + 1}\nGain of Rs.\n${gainOrLoss.toLocaleString()}`;
    }
  };

  const scenarioTable = [
    [
      { text: 'Fee Illustration', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Variable', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Formula', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: generatePROScenarioHeader(0, scenarios[0].gainOrLoss), bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: generatePROScenarioHeader(1, scenarios[1].gainOrLoss), bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: generatePROScenarioHeader(2, scenarios[2].gainOrLoss), bold: true, alignment: 'center', fillColor: '#f5e6d3' },
    ],
    [
      'Capital Contributed / Assets under Management',
      { text: 'i', alignment: 'center' },
      { text: 'i = a', alignment: 'center' },
      { text: formatNumber(scenarios[0].capital), alignment: 'right' },
      { text: formatNumber(scenarios[1].capital), alignment: 'right' },
      { text: formatNumber(scenarios[2].capital), alignment: 'right' },
    ],
    [
      'Derivative Income/All Income during the year',
      { text: 'ii', alignment: 'center' },
      { text: 'ii = Gain / (Loss)', alignment: 'center' },
      { text: formatNumber(scenarios[0].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[1].gainOrLoss), alignment: 'right' },
      { text: formatNumber(scenarios[2].gainOrLoss), alignment: 'right' },
    ],
    [
      'Gross Value of the Portfolio at the end of the year',
      { text: 'iii', alignment: 'center' },
      { text: 'iii = i + ii', alignment: 'center' },
      { text: formatNumber(scenarios[0].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[1].grossValue), alignment: 'right' },
      { text: formatNumber(scenarios[2].grossValue), alignment: 'right' },
    ],
    [
      'Daily Weighted Average assets under management',
      { text: 'iv', alignment: 'center' },
      { text: 'iv = (i + iii) / 2', alignment: 'center' },
      { text: formatNumber(scenarios[0].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[1].averageAUM), alignment: 'right' },
      { text: formatNumber(scenarios[2].averageAUM), alignment: 'right' },
    ],
    [
      'Other Expense',
      { text: 'v', alignment: 'center' },
      { text: 'v = iv * d', alignment: 'center' },
      { text: formatNumber(scenarios[0].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[1].otherExpense), alignment: 'right' },
      { text: formatNumber(scenarios[2].otherExpense), alignment: 'right' },
    ],
    [
      'Brokerage and Transaction cost',
      { text: 'vi', alignment: 'center' },
      { text: 'vi = iv * e', alignment: 'center' },
      { text: formatNumber(scenarios[0].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[1].brokerageCost), alignment: 'right' },
      { text: formatNumber(scenarios[2].brokerageCost), alignment: 'right' },
    ],
    [
      'Management Fees',
      { text: 'vii', alignment: 'center' },
      { text: 'vii = (iv + v + vi) * c', alignment: 'center' },
      { text: formatNumber(scenarios[0].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[1].managementFees), alignment: 'right' },
      { text: formatNumber(scenarios[2].managementFees), alignment: 'right' },
    ],
    [
      'GST on Management Fees',
      { text: 'viii', alignment: 'center' },
      { text: 'viii = vii * 18%', alignment: 'center' },
      { text: formatNumber(scenarios[0].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].gstOnManagementFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].gstOnManagementFee), alignment: 'right' },
    ],
    [
      'Total charges excluding performance fee',
      { text: 'ix', alignment: 'center' },
      { text: 'ix = v + vi + vii + viii', alignment: 'center' },
      { text: formatNumber(scenarios[0].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[1].totalCharges), alignment: 'right' },
      { text: formatNumber(scenarios[2].totalCharges), alignment: 'right' },
    ],
    [
      'Gross Value of the Portfolio before Performance fee',
      { text: 'x', alignment: 'center' },
      { text: 'x = iii + ix', alignment: 'center' },
      { text: formatNumber(scenarios[0].grossValueBeforePerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].grossValueBeforePerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].grossValueBeforePerformanceFee), alignment: 'right' },
    ],
    [
      'Performance Fee Applicability',
      { text: 'xi', alignment: 'center' },
      { text: 'If(ii+vii) > 0, then Yes else No', alignment: 'center' },
      { text: scenarios[0].performanceFeeApplicability, alignment: 'center' },
      { text: scenarios[1].performanceFeeApplicability, alignment: 'center' },
      { text: scenarios[2].performanceFeeApplicability, alignment: 'center' },
    ],
    [
      'Portfolio return subject to Performance Fee',
      { text: 'xii', alignment: 'center' },
      { text: 'If xi=Yes,then ((ii+vii) else 0', alignment: 'center' },
      { text: formatNumber(scenarios[0].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].portfolioReturnSubjectToPerformanceFee), alignment: 'right' },
    ],
    [
      'Performance Fee',
      { text: 'xiii', alignment: 'center' },
      { text: 'xiii = xii * f', alignment: 'center' },
      { text: formatNumber(scenarios[0].performanceFeeAmount), alignment: 'right' },
      { text: formatNumber(scenarios[1].performanceFeeAmount), alignment: 'right' },
      { text: formatNumber(scenarios[2].performanceFeeAmount), alignment: 'right' },
    ],
    [
      'GST on Performance Fee (Rs.)',
      { text: 'xiv', alignment: 'center' },
      { text: 'xiv = xiii * 18%', alignment: 'center' },
      { text: formatNumber(scenarios[0].gstOnPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[1].gstOnPerformanceFee), alignment: 'right' },
      { text: formatNumber(scenarios[2].gstOnPerformanceFee), alignment: 'right' },
    ],
    [
      'Net value of the Portfolio at the end of the year after all fees and expenses',
      { text: 'xv', alignment: 'center' },
      { text: 'xv = x + xii + xiv', alignment: 'center' },
      { text: formatNumber(scenarios[0].netValueAfterFees), alignment: 'right' },
      { text: formatNumber(scenarios[1].netValueAfterFees), alignment: 'right' },
      { text: formatNumber(scenarios[2].netValueAfterFees), alignment: 'right' },
    ],
    // [
    //   '% Portfolio Return',
    //   { text: 'xvi', alignment: 'center' },
    //   { text: 'xvi = ((xv - i) / i) %', alignment: 'center' },
    //   { text: `${scenarios[0].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
    //   { text: `${scenarios[1].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
    //   { text: `${scenarios[2].portfolioReturn?.toFixed(2) || 'N/A'}%`, alignment: 'right' },
    // ],
  ];

  const notes = [
    'Other Expense include Account Opening charges, stamp duty / Audit Fee / Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous ',
    'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM.However,Brokerage and Transaction cost are charged on basis the actuals trades.',
    'All Fees and charges are subject to GST at 18% or as per extant regulations.',
    'All Amounts are in INR.',
  ];

  return {
    title: `HYBRID FEE MODEL - ${selectedApproach}`,
    assumptionsTable: assumptionsTableBody,
    scenarioTable,
    notes,
  };
};

const generateScenarioHeader = (index, gainOrLoss, capital) => {
  const year = index + 1;
  const scenarioPercent = ((gainOrLoss / capital) * 100).toFixed(0);
  if (scenarioPercent == 0) {
    return `Yr ${year}\nNil Gain/Loss`;
  } else if (scenarioPercent > 0) {
    return `Yr ${year}\nGain of ${scenarioPercent}%`;
  } else {
    return `Yr ${year}\nLoss of ${Math.abs(scenarioPercent)}%`;
  }
};

const buildMultiYearContent = (scenarios, assumptions, selectedFeeModel, selectedApproach, feeDetails) => {
  let title;
  let notes;
  let assumptionsTableBody;

  if (selectedFeeModel === 'MultiYearHybrid' && selectedApproach === 'Portfolio Return Optimiser') {
    title = `HYBRID FEE MODEL - ${selectedApproach}`;
    assumptionsTableBody = [
      [
        { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
        {},
        {},
      ],
      [
        'Capital Contribution',
        { text: 'a', alignment: 'center' },
        { text: formatNumber(assumptions.a), alignment: 'right' },
      ],
      [
        'Cash Component out of Total Capital',
        { text: 'b', alignment: 'center' },
        { text: formatNumber(assumptions.a * 0.02), alignment: 'right' },
      ],
      [
        'Management Fee (%age per annum)',
        { text: 'c', alignment: 'center' },
        { text: `${assumptions.b}%`, alignment: 'right' },
      ],
      [
        'Other Expenses (% pa including GST)',
        { text: 'd', alignment: 'center' },
        { text: `${assumptions.c}%`, alignment: 'right' },
      ],
      [
        'Brokerage and Transaction cost (% pa including GST)',
        { text: 'e', alignment: 'center' },
        { text: `${assumptions.d}%`, alignment: 'right' },
      ],
      [
        'Performance Fee(%age per annum)',
        { text: 'f', alignment: 'center' },
        { text: `${assumptions.e}%`, alignment: 'right' },
      ],
    ];
    notes = [
      'Other Expense includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense.',
      'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades.',
      'All Fees and charges are subject to GST at 18% or as per extant regulations',
      'All Amounts are in INR.',
    ];
  } else if (selectedFeeModel === 'MultiYearFixed') {
    title = `FIXED FEE MODEL - ${selectedApproach}`;
    assumptionsTableBody = [
      [
        { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
        {},
        {},
      ],
      [
        'Capital Contribution (Rs.)',
        { text: 'a', alignment: 'center' },
        { text: formatNumber(assumptions.a), alignment: 'right' },
      ],
      [
        'Management Fee (% per annum)',
        { text: 'b', alignment: 'center' },
        { text: `${assumptions.b}%`, alignment: 'right' },
      ],
      [
        'Other Expenses (% pa including GST)',
        { text: 'c', alignment: 'center' },
        { text: `${assumptions.c}%`, alignment: 'right' },
      ],
      [
        'Brokerage and Transaction cost (% pa including GST)',
        { text: 'd', alignment: 'center' },
        { text: `${assumptions.d}%`, alignment: 'right' },
      ],
    ];
    notes = [
      'Returns are assumed to be generated linearly through the year.',
      'Other Expense includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense.',
      'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades.',
      'All Fees and charges are subject to GST at 18% or as per extant regulations',
      'All Amounts are in INR.',
    ];
  } else {
    title = `HYBRID FEE MODEL - ${selectedApproach}`;
    assumptionsTableBody = [
      [
        { text: 'Assumptions', colSpan: 3, bold: true, alignment: 'center', fillColor: '#f5e6d3' },
        {},
        {},
      ],
      [
        'Capital Contribution (Rs.)',
        { text: 'a', alignment: 'center' },
        { text: formatNumber(assumptions.a), alignment: 'right' },
      ],
      [
        'Management Fee (% per annum)',
        { text: 'b', alignment: 'center' },
        { text: `${assumptions.b}%`, alignment: 'right' },
      ],
      [
        'Other Expenses (% pa including GST)',
        { text: 'c', alignment: 'center' },
        { text: `${assumptions.c}%`, alignment: 'right' },
      ],
      [
        'Performance Fee(% per annum)',
        { text: 'd', alignment: 'center' },
        { text: `${assumptions.e}%`, alignment: 'right' },
      ],
      [
        'Hurdle Rate of Return (% per annum)',
        { text: 'e', alignment: 'center' },
        { text: assumptions.f, alignment: 'right' },
      ],
      [
        'Brokerage and Transaction cost (% pa including GST)',
        { text: 'f', alignment: 'center' },
        { text: `${assumptions.d}%`, alignment: 'right' },
      ],
    ];
    notes = [
      'Returns are assumed to be generated linearly through the year.',
      'Other Expense includes Account Opening charges, stamp duty /Audit Fee/ Bank charges / Fund Accounting charges / Custody Fee / demat charges or other miscellaneous expense.',
      'Brokerage and transaction cost for the illustration purpose is charged on the Average AUM. However, Brokerage and Transaction cost are charged on basis the actuals trades.',
      'All Fees and charges are subject to GST at 18% or as per extant regulations',
      'For this illustration, High Water Mark for the 1st Year is the Capital invested and from second year onwards it will be higher of Hurdle Value or Net Portfolio Value post charging all fees and expenses.',
      'Hurdle computation is prorated in case the performance fee period is less than 1 year OR if there are inflow/outflows from the portfolio.',
      'All Amounts are in INR.',
    ];
  }

  const generateMultiYearPROHeader = (index, gainOrLoss) => {
    const year = index + 1;
    if (gainOrLoss < 0) {
      return `Yr ${year}\nLoss of Rs.\n${Math.abs(gainOrLoss).toLocaleString()}`;
    } else if (gainOrLoss === 0) {
      return `Yr ${year}\nNil\nGain/Loss`;
    } else {
      return `Yr ${year}\nGain of Rs.\n${gainOrLoss.toLocaleString()}`;
    }
  };

  const scenarioTable = [
    [
      { text: 'Fee Illustration', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Variable', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      { text: 'Formula', bold: true, alignment: 'center', fillColor: '#f5e6d3' },
      ...(selectedFeeModel === 'MultiYearHybrid' && selectedApproach === 'Portfolio Return Optimiser'
        ? scenarios.map((s, i) => ({ text: generateMultiYearPROHeader(i, s.gainOrLoss), bold: true, alignment: 'center', fillColor: '#f5e6d3' }))
        : scenarios.map((s, i) => ({ text: generateScenarioHeader(i, s.gainOrLoss, s.capital), bold: true, alignment: 'center', fillColor: '#f5e6d3' }))),
    ],
  ];

  if (selectedFeeModel === 'MultiYearHybrid' && selectedApproach === 'Portfolio Return Optimiser') {
    const rows = [
      buildMultiYearRow('Capital Contributed / Assets under Management', 'i', 'i = a (for 1st year); i = xvii (from 2nd year onwards)', scenarios.map(s => formatNumber(s.capital || s.averageAUM))),
      buildMultiYearRow('Derivative Income/All Income during the year', 'ii', 'ii = Gain / (Loss)', scenarios.map(s => formatNumber(s.gainOrLoss))),
      buildMultiYearRow('Gross Value of the Portfolio at the end of the year', 'iii', 'iii = i + ii', scenarios.map(s => formatNumber(s.grossValue))),
      buildMultiYearRow('Daily Weighted Average assets under management', 'iv', 'iv = (i + iii) / 2', scenarios.map(s => formatNumber(s.averageAUM))),
      buildMultiYearRow('Other Expense', 'v', 'v = iv * d', scenarios.map(s => formatNumber(s.otherExpense))),
      buildMultiYearRow('Brokerage and Transaction cost', 'vi', 'vi = iv * e', scenarios.map(s => formatNumber(s.brokerageCost))),
      buildMultiYearRow('Management Fees', 'vii', 'vii = (iv + v + vi) * c', scenarios.map(s => formatNumber(s.managementFees))),
      buildMultiYearRow('GST on Management Fees', 'viii', 'viii = vii * 18%', scenarios.map(s => formatNumber(s.gstOnManagementFee))),
      buildMultiYearRow('Total charges excluding performance fee', 'ix', 'ix = v + vi + vii + viii', scenarios.map(s => formatNumber(s.totalCharges))),
      buildMultiYearRow('Gross Value of the Portfolio before Performance fee', 'x', 'x = iii + ix', scenarios.map(s => formatNumber(s.grossValueBeforePerformanceFee))),
      buildMultiYearRow('Performance Fee Applicability', 'xi', 'If(ii+vii) > 0, then Yes else No', scenarios.map(s => s.performanceFeeApplicability === 'Yes' ? 'Yes' : 'No')),
      buildMultiYearRow('Portfolio return subject to Performance Fee', 'xii', 'If xi=Yes, then ((ii+vii) else 0', scenarios.map(s => formatNumber(s.portfolioReturnSubjectToPerformanceFee))),
      buildMultiYearRow('Previous year loss carried forward if any', 'xiii', 'If xviii < 0, then xviii, else 0', scenarios.map((s, i) => {
        if (i === 0) return formatNumber(0);
        const prevLoss = scenarios[i - 1].gainOrLoss;
        return formatNumber(prevLoss < 0 ? prevLoss : 0);
      })),
      buildMultiYearRow('Net Return subject to Performance Fee', 'xiv', 'xiv = xii + xiii', scenarios.map((s, i) => formatNumber(s.portfolioReturnSubjectToPerformanceFee + (i === 0 ? 0 : (scenarios[i-1].gainOrLoss < 0 ? scenarios[i-1].gainOrLoss : 0))))),
      buildMultiYearRow('Performance Fee', 'xv', 'xv = xiv * f', scenarios.map(s => formatNumber(s.performanceFeeAmount))),
      buildMultiYearRow('GST on Performance Fee (Rs.)', 'xvi', 'xvi = xv * 18%', scenarios.map(s => formatNumber(s.gstOnPerformanceFee))),
      buildMultiYearRow('Net value of the Portfolio at the end of the year after all fees and expenses', 'xvii', 'xvii = x + xv + xvi', scenarios.map((s, i) => {
        const x = s.grossValueBeforePerformanceFee;
        const xv = s.performanceFeeAmount;
        const xvi = s.gstOnPerformanceFee;
        return formatNumber(x + xv + xvi);
      })),
      buildMultiYearRow('Loss carried forward if any', 'xviii', 'If ii < 0, then ii, else 0', scenarios.map(s => formatNumber(s.gainOrLoss < 0 ? s.gainOrLoss : 0))),
    ];
    scenarioTable.push(...rows);
  } else if (selectedFeeModel === 'MultiYearFixed') {
    const rows = [
      buildMultiYearRow('Capital Contributed / Assets under Management', 'i', 'i=a (for 1st year); i=x (from 2nd year onwards)', scenarios.map(s => formatNumber(s.capital || s.averageAUM))),
      buildMultiYearRow('Gain / (Loss) on Investment based on the Scenario', 'ii', 'ii = i * Scenario', scenarios.map(s => formatNumber(s.gainOrLoss))),
      buildMultiYearRow('Gross Value of the Portfolio at the end of the year', 'iii', 'iii = i + ii', scenarios.map(s => formatNumber(s.grossValue))),
      buildMultiYearRow('Daily Weighted Average assets under management', 'iv', 'iv = (i + iii) / 2', scenarios.map(s => formatNumber(s.averageAUM))),
      buildMultiYearRow('Other Expense', 'v', 'v = iv * c', scenarios.map(s => formatNumber(s.otherExpense))),
      buildMultiYearRow('Brokerage and Transaction cost', 'vi', 'vi = iv * d', scenarios.map(s => formatNumber(s.brokerageCost))),
      buildMultiYearRow('Management Fees', 'vii', 'vii = (iv + v + vi) * b', scenarios.map(s => formatNumber(s.managementFees))),
      buildMultiYearRow('GST on Management Fees', 'viii', 'viii = vii * 18%', scenarios.map(s => formatNumber(s.gstOnManagementFee))),
      buildMultiYearRow('Total charges before Performance fee', 'ix', 'ix = v + vi + vii + viii', scenarios.map(s => formatNumber(s.totalCharges))),
      buildMultiYearRow('Net value of the Portfolio at the end of the year after all fees and expenses', 'x', 'x = iii + ix', scenarios.map(s => formatNumber(s.netValueAfterFees))),
      buildMultiYearRow('% Portfolio Return for the year', 'xi', 'xi = ((x - i) / i) %', scenarios.map(s => `${s.portfolioReturn?.toFixed(2) || 'N/A'}%`)),
    ];
    scenarioTable.push(...rows);
  } else {
    const rows = [
      buildMultiYearRow('Capital Contributed / Assets under Management', 'i', 'i=a (for 1st year); i=xvi(from 2nd year onwards)', scenarios.map(s => formatNumber(s.capital || s.averageAUM))),
      buildMultiYearRow('Gain / (Loss) on Investment based on the Scenario', 'ii', 'ii = i * Scenario', scenarios.map(s => formatNumber(s.gainOrLoss))),
      buildMultiYearRow('Gross Value of the Portfolio at the end of the year', 'iii', 'iii = i + ii', scenarios.map(s => formatNumber(s.grossValue))),
      buildMultiYearRow('Daily Weighted Average assets under management', 'iv', 'iv = (i + iii) / 2', scenarios.map(s => formatNumber(s.averageAUM))),
      buildMultiYearRow('Other Expense', 'v', 'v = iv * c', scenarios.map(s => formatNumber(s.otherExpense))),
      buildMultiYearRow('Brokerage and Transaction cost', 'vi', 'vi = iv * f', scenarios.map(s => formatNumber(s.brokerageCost))),
      buildMultiYearRow('Management Fees', 'vii', 'vii = (iv + v + vi) * b', scenarios.map(s => formatNumber(s.managementFees))),
      buildMultiYearRow('GST on Management Fees', 'viii', 'viii = vii * 18%', scenarios.map(s => formatNumber(s.gstOnManagementFee))),
      buildMultiYearRow('Total charges before Performance fee', 'ix', 'ix = v + vi + vii + viii', scenarios.map(s => formatNumber(s.totalCharges))),
      buildMultiYearRow('Gross Value of the Portfolio before Performance fee', 'x', 'x = iii + ix', scenarios.map(s => formatNumber(s.grossValueBeforePerformanceFee))),
      buildMultiYearRow('Hurdle Value', 'xi', '1st year xi = i*(1+e); 2nd year onwards xi=Previous years xviii*(1+e)', scenarios.map(s => formatNumber(s.HurdleValue))),
      buildMultiYearRow('Performance Fee Applicability', 'xii', 'xii = x > xi then Yes else No', scenarios.map(s => s.grossValueBeforePerformanceFee > s.HurdleValue ? 'Yes' : 'No')),
      buildMultiYearRow('Portfolio return subject to Performance Fee', 'xiii', 'xiii = x - xi', scenarios.map(s => formatNumber(s.portfolioReturnSubjectToPerformanceFee))),
      buildMultiYearRow('Performance Fee', 'xiv', 'xiv = xiii * d', scenarios.map(s => formatNumber(s.performanceFeeAmount))),
      buildMultiYearRow('GST on Performance Fee (Rs.)', 'xv', 'xv = xiv * 18%', scenarios.map(s => formatNumber(s.gstOnPerformanceFee))),
      buildMultiYearRow('Net value of the Portfolio at the end of the year after all fees and expenses', 'xvi', 'xvi = x+xiv+xv', scenarios.map(s => formatNumber(s.netValueAfterFees))),
      buildMultiYearRow('% Portfolio Return for the year', 'xvii', 'xvii = ((xvi - i) / i) %', scenarios.map(s => `${s.portfolioReturn?.toFixed(2) || 'N/A'}%`)),
      buildMultiYearRow('High Water Mark to be carried forward for next year (when performance fee is charged to the portfolio)', 'xviii', 'xviii = Max(xi, xvi)', scenarios.map(s => formatNumber(s.highWaterMark))),
      buildMultiYearRow('High Water Mark to be carried forward for next year (when performance fee is paid separately by investor in that particular year)', 'xix', 'xix = Max(x, xi)', scenarios.map(s => formatNumber(s.highWaterMarkInvestor))),
    ];
    scenarioTable.push(...rows);
  }

  return {
    title,
    assumptionsTable: assumptionsTableBody,
    scenarioTable,
    notes,
  };
};

const STRATEGY_SHORTCODE_MAP = {
  'Agreya Momentum': 'MOM',
  'Agreya Total Return': 'TR',
  'Agreya Multi-Asset': 'MA',
  'Agreya Multi-Asset Enhancer': 'MAE',
  'Agreya Total Return Enhancer': 'TRE',
  'Agreya Momentum Enhancer': 'MOM-E',
  'Portfolio Return Optimiser': 'PRO',
  'Agreya Value Momentum Strategy': 'VMOS'
};

const generatePdfFilename = (selectedFeeModel, selectedApproach) => {
  let feeType = '';
  let duration = '';

  if (selectedFeeModel === 'Fixed') {
    feeType = 'Fixed';
    duration = '1Y';
  } else if (selectedFeeModel === 'Hybrid' || selectedFeeModel === 'Portfolio Return Optimiser') {
    feeType = 'Hybrid';
    duration = '1Y';
  } else if (selectedFeeModel === 'MultiYearFixed') {
    feeType = 'Fixed';
    duration = 'MultiYear';
  } else if (selectedFeeModel === 'MultiYearHybrid') {
    feeType = 'Hybrid';
    duration = 'MultiYear';
  }

  const strategyShortcode = STRATEGY_SHORTCODE_MAP[selectedApproach] || selectedApproach;

  return `${feeType}-${duration}-${strategyShortcode}.pdf`;
};

export const generatePDF = async (selectedFeeModel, selectedApproach, scenarios, assumptions, feeDetails) => {
  let content;
  let title;

  if (selectedFeeModel === 'Fixed') {
    content = buildFixedFeeContent(scenarios, assumptions, selectedApproach);
  } else if (selectedFeeModel === 'Hybrid' && selectedApproach !== 'Portfolio Return Optimiser') {
    content = buildHybridFeeContent(scenarios, assumptions, selectedApproach);
  } else if (selectedFeeModel === 'Hybrid' && selectedApproach === 'Portfolio Return Optimiser') {
    // Single-year Portfolio Return Optimiser - use dedicated builder
    content = buildPortfolioOptimiserContent(scenarios, assumptions, selectedApproach);
  } else if (selectedFeeModel === 'MultiYearFixed' || selectedFeeModel === 'MultiYearHybrid') {
    content = buildMultiYearContent(scenarios, assumptions, selectedFeeModel, selectedApproach, feeDetails);
  } else {
    console.warn('PDF generation not yet configured for this fee model');
    return;
  }

  title = content.title;

  const scenarioColumnCount = content.scenarioTable[0].length - 3;
  const baseWidths = ['25%', '6%', '12%'];
  const scenarioWidths = Array(scenarioColumnCount).fill((100 - 43) / scenarioColumnCount + '%');
  const tableWidths = [...baseWidths, ...scenarioWidths];

  // Load logo as base64 data URL
  let logoDataUrl = '';
  try {
    const logoPath = require('../assets/images/logo.png');
    const response = await fetch(logoPath);
    const blob = await response.blob();
    logoDataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.warn('Could not load logo:', e);
  }

  const docDefinition = {
    content: [
      {
        columns: [
          logoDataUrl ? {
            image: logoDataUrl,
            width: 40,
            margin: [0, 0, 10, 0],
          } : {},
          {
            text: title,
            fontSize: 14,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 0],
          },
        ],
        margin: [0, 0, 0, 15],
      },
      {
        text: 'Assumptions',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      {
        table: {
          headerRows: 1,
          widths: ['45%', '12%', '43%'],
          body: content.assumptionsTable,
        },
        margin: [0, 0, 0, 15],
      },
      {
        text: 'Fee Illustration',
        fontSize: 11,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: content.scenarioTable,
          dontBreakRows: false,
        },
        margin: [0, 0, 0, 15],
        fontSize: 8,
      },
      {
        text: 'Notes:',
        fontSize: 9,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      {
        ul: content.notes,
        margin: [20, 0, 0, 15],
        fontSize: 8,
      },
      {
        text: 'Disclaimer:',
        fontSize: 9,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      {
        text: DISCLAIMER,
        fontSize: 7.5,
        italics: true,
        alignment: 'justify',
        margin: [0, 0, 0, 0],
      },
    ],
    defaultStyle: {
      fontSize: 8,
    },
    styles: {
      table: {
        fontSize: 7.5,
      },
      tableHeader: {
        fontSize: 7.5,
        bold: true,
      },
    },
    info: {
      title: title,
      author: 'Agreya Capital Advisors LLP',
      subject: 'Fee Illustration',
      keywords: 'Fee Illustration, Portfolio Management',
    },
  };

  const filename = generatePdfFilename(selectedFeeModel, selectedApproach);
  pdfMake.createPdf(docDefinition).download(filename);
};
